import * as $ from "jquery";
import Bao from "../../projectx/services/bao-service";
import * as ko from "knockout";
import BaoDialog from "../../projectx/factories/bao-dialog";
import BaseViewModel from "./../factories/base-view-model2";
import TabPage from "./../factories/tab-page";
import WorkplacePlanningCopyDialog from "./dialogs/workplace-planning-copy-dialog";
import {ReportCenterReports} from "../constants/report-center-reports";
import * as moment from "moment";
import baoRouter from "./../services/bao-router";

export interface ShiftPlanQualificationModel {
    CIPersonId: string;
    PersonFullName: string;
    WorkplaceId: string;
    Workplace: any;
    WorkplaceName: string;
    IsInTraining: boolean;
    IsAdditionalResource: boolean;
    Remark: string;
    ShiftTypeId: string;
    ShiftbookId: string;
    ShiftGroupId: string;
    ValidDateJs: string;
    IsNew: boolean;
    Person: any;
    IsPersonIncorrect: boolean;
    IsWrongQualification: boolean;
    IsAlreadyAssigned: boolean;
    IsAbsent: boolean;
    QualificationIdsByWorkplace: string;
    QualificationIdsByPerson: string;
    ValidDate: string;
    SyncId: number;
}

export interface PrevShiftPlanQualificationModel{
    CIPersonId: string;
    WorkplaceId: string;
    DayIndex: number;
}

// This class is used for workplaceplanning 
class WorkplacePlanning extends BaseViewModel{

    // required by base class
    InitUrl() {
        return "";
    }
    CompleteCheck() {
        return true;
    }

    Bao = Bao;
    PageSize = ko.observable(0);
    TotalRows = ko.observable(0);
    PageIndex = ko.observable(0);
    StartDateTime = ko.observable('');
    EndDateTime = ko.observable('');
    ShiftGroupId = ko.observable('');
    ShiftGroupName = ko.observable('');
    ShiftBookId: KnockoutObservableArray<string> = ko.observableArray([]);
    ShiftBookName = ko.observable('');
    ShiftBook: KnockoutObservableArray<string> = ko.observableArray([]);
    Calendar = ko.observableArray([]);
    JobOccupationCollection = ko.observableArray([]);
    ResultCollection = ko.observableArray([]);
    ShiftplanQualificationCollectionToDelete= ko.observableArray<ShiftPlanQualificationModel>([]);
    PreviousWorkplaceModels: KnockoutObservableArray<any> = ko.observableArray([]);
    IsReportResultEmpty = ko.observable(false);
    ReportHTML = ko.observable<HTMLElement>();
    LastRowCellHTML = ko.observable<HTMLElement>();
    AbsentCellHTML = ko.observable<HTMLElement>();
    FromDailyShiftPlan = ko.observable(false);
    ShiftbookIdsStringifiedForCustomFilter: KnockoutObservable<string> = ko.observable("");
    radioDataSource = ko.observable("ShiftplanQualification");
    RemoveShiftbookGroup = ko.observable(false);
    DisplayView: KnockoutObservable<string> = ko.observable('horizontal');
    MessageHoliday = ko.observable('');
    MessageAbsent = ko.observable('');
    MessageNotUsedEmployees = ko.observable('');
    ColumnWidth = ko.observable<string>('');
    /**
     * True if the user has permission to the daily shift plan 
     */
    HasPermissionToDailyShiftPlan = ko.observable(false);

    SidebarTop: KnockoutObservable<string> = ko.observable('0');
    HeaderLeft: KnockoutObservable<string> = ko.observable('0');

    SearcherShiftBook: any;

    SearcherShiftGroup: Bindings.baoSearcher = {
        ObjectId: this.ShiftGroupId,
        ObjectValue: 'Name',
        SearchType: 'ShiftGroup',
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ShiftbookIds: this.ShiftbookIdsStringifiedForCustomFilter }
    };

    constructor(tabPage: TabPage) {
        super(tabPage);     

        this.SearcherShiftBook = {
            SearchType: 'ShiftBook',
            ObjectId: this.ShiftBookId,
            ObjectValue: 'Name',
            AutoComplete: true,
            AutoSearch: true,
            MultiSelect: true,
            Items: this.ShiftBook,
            CustomFilter: { CurrentUserHasIsInShiftplanAllowed: true }
        };
        this.ShiftBookId.subscribe(() => {
            this.ShiftbookIdsStringifiedForCustomFilter(JSON.stringify(this.ShiftBookId()));
        });       

        this.TabPage.IsActiveTab.subscribe(() => {
            if (this.TabPage.IsActiveTab()) {
                this.recalcSchedulePosition();
                this.recalcScroll();
            }
        });
        this.LastRowCellHTML.subscribe(() => {
            $(this.AbsentCellHTML()).height($(this.LastRowCellHTML()).height());
        });
        this.ShiftBook.subscribe(() => {
            this.ShiftGroupId('');
            this.ShiftGroupName('');
        });

        this.StartDateTime.subscribe(() => {
            let startDate = moment(this.StartDateTime(), Bao.Utils.DateTimeFormat);
            let endDate = moment(this.EndDateTime(), Bao.Utils.DateTimeFormat);

            if (startDate > endDate) { 
                let newEndDate = startDate.add(7, "d").format(Bao.Utils.DateTimeFormat);
                this.EndDateTime(newEndDate)             
            }
        })

        this.TabPage.MenuEvents.push(this.Menu.registerEvent((btnClicked) => {
            if (this.TabPage.IsActiveTab() !== true) {
                return;
            }
            switch (btnClicked.ActionKey()) {
                case "WorkplaceplanningSave":
                    this.saveData();
                    break;
                case "WorkplacePlanningCopy":
                    this.openCopyDialog();
                    break;
                case "WorkplaceplanningJobOccupationReport":
                    this.openReportCenter();
                    break;
                case "WorkplaceplanningEvoPDFReport":
                    this.DownloadEvoPdfHtmlReportWorkplacePlanning();
                    break;
            }
        }));
    }  

    loaded() {

        $(this.ReportHTML()).parents(".col-lg-12").eq(1).find("select.form-control").eq(0).css({ "position": "fixed", "width": "65.7%", "z-index": "500" });
        window.addEventListener('scroll', this.ScrollEventHandler);
        window.addEventListener('resize', this.ResizeEventHandler);
        this.recalcSchedulePosition();
        this.recalcScroll();
        this.getMetaDataFromServer();
        this.TabPage.IsLoading(false);
    }

    Display = ( isInInit: boolean) => {      
        if (this.checkFilters(isInInit)) {
            this.TabPage.IsLoading(true);
            if(this.TabPage.IsDirty()){
                this.CheckDirtyFlagForDisplay();
            }
            else{             
                this.getDataFromServer().then(data => {                    
                    this.recalcScroll();
                    this.TabPage.DirtyFlag(false);
                    this.TabPage.IsLoading(false);
                });
            }
            
        }
    }

       

     checkFilters(isInInit: boolean): boolean {
        var completed = true;
        if (!this.ShiftBookId() || this.ShiftBookId().length === 0 || !this.StartDateTime() || !this.EndDateTime()) {
            completed = false;
        }

        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
           
        }

        if (this.StartDateTime() > this.EndDateTime()) {
            var baoDialogStaffingWrongDateError = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgStaffingWrongDateError"), "info");
            
            completed = false;
        }

        return completed;
    }

     getMetaDataFromServer() {
        return Bao.post("WorkplacePlanning/GetWorkplacePlanningMetaData", JSON.stringify({
            shiftBookId: this.ShiftBookId(),
            shiftGroupId: this.ShiftGroupId()
        })).then(result => {
            this.TabPage.Title(result.MsgWorkplaceplanning);
            this.MessageAbsent(result.MsgAbsent);
            this.MessageHoliday(result.MsgHoliday);
            this.MessageNotUsedEmployees(result.msgNotUsedEmployees);
            this.HasPermissionToDailyShiftPlan(result.HasPermissionToDailyShiftPlan);
            if (result.ByUserProfile === true) {
                this.ShiftBookId(result.shiftbookIds);
                this.ShiftBookName(result.shiftbookNames);
                this.RemoveShiftbookGroup(result.RemoveShiftbookGroup);
                if (!this.ShiftGroupId()) {
                    this.ShiftGroupId(result.ShiftGroupId);
                    this.ShiftGroupName(result.ShiftGroupName);
                }
                if (!this.StartDateTime()) {
                    this.StartDateTime(result.StartDateTime);
                }
                if (!this.EndDateTime()) {
                    this.EndDateTime(result.EndDateTime);
                }

                this.TabPage.IsLoading(false);
                this.Display(true);
            }
            else {
                this.ShiftBookId(result.ShiftBookId);
                this.ShiftBookName(result.ShiftBookName);
                if (!this.ShiftGroupId()) {
                    this.ShiftGroupId(result.ShiftGroupId);
                    this.ShiftGroupName(result.ShiftGroupName);
                }
                if (!this.StartDateTime()) {
                    this.StartDateTime(result.StartDateTime);
                }
                if (!this.EndDateTime()) {
                    this.EndDateTime(result.EndDateTime);
                }
                this.TabPage.IsLoading(false);

                this.Display(true);
            }

        });
    }


     saveData() {        
            this.TabPage.IsLoading(true);
            
            var shiftPlanQualificationCollectionToSave = ko.observableArray<ShiftPlanQualificationModel>([]);
            this.ResultCollection().forEach(resultModel => {
                for(var i = 0; i < resultModel.Calendar.length; i++){                    
                    resultModel.WorkplacePlanningCollection().forEach(workplacePlanningModel => {                                          
                        if(workplacePlanningModel.IsStatic !== true && resultModel.Calendar.IsNonWorkingShift !== true &&
                            workplacePlanningModel.Employees[i].SelectedShiftPlanQualificationModel() !== null && workplacePlanningModel.Employees[i].SelectedShiftPlanQualificationModel() !== undefined
                            && workplacePlanningModel.Employees[i].SelectedShiftPlanQualificationModel().ShiftPlanQualificationId !== null) {

                            let validDate = moment.parseZone(resultModel.Calendar[i].Date).format("YYYY-MM-DDTHH:mm:ss");
                            workplacePlanningModel.Employees[i].SelectedShiftPlanQualificationModel().ValidDate = validDate;
                            workplacePlanningModel.Employees[i].SelectedShiftPlanQualificationModel().ValidDateJs = moment(validDate, Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeFormat);

                            let model = this.GetWorkplacePlanningModel(workplacePlanningModel.Employees[i].SelectedShiftPlanQualificationModel(), resultModel.Calendar[i], workplacePlanningModel.DefaultShiftbookId);
                            shiftPlanQualificationCollectionToSave.push(model);
                            }
                        else {                            
                            if(workplacePlanningModel.Employees[i].DefaultModelToSave !== null && workplacePlanningModel.Employees[i].DefaultModelToSave !== undefined){                                
                                shiftPlanQualificationCollectionToSave.push(workplacePlanningModel.Employees[i].DefaultModelToSave);
                            }                                
                        }                                              
                    });
                }
            });
            if(this.checkFilters(false)){
                return Bao.post("WorkplacePlanning/SaveWorkplaceplanningData", JSON.stringify({
                    workplaceplanningCollection: ko.map.toJS(shiftPlanQualificationCollectionToSave),
                    shiftBookId: this.ShiftBookId(),
                    shiftgroupId: this.ShiftGroupId(),
                    workplaceplanningCollectionToDelete: ko.map.toJS(this.ShiftplanQualificationCollectionToDelete)
                })).done(result => {
                    this.TabPage.DirtyFlag(false);
                    this.TabPage.IsLoading(false);
                    this.ShiftplanQualificationCollectionToDelete = ko.observableArray<ShiftPlanQualificationModel>([]);
                    this.Display(false);
                });
            }
            
            this.TabPage.IsLoading(false);
    }    

    removeRow(model: any) {
        this.ResultCollection().forEach(item => {
            var found = false;
            for(var workplaceplanning  of item.WorkplacePlanningCollection()){
                if(workplaceplanning.InTrainingId == model.InTrainingId){
                    found = true;
                    break;
                }
            }
            if(found){
                model.Employees.forEach(cell => {
                    if(cell.SelectedShiftPlanQualificationModel() !== null && cell.SelectedShiftPlanQualificationModel() !== undefined){
                        this.ShiftplanQualificationCollectionToDelete().push(cell.SelectedShiftPlanQualificationModel());
                    }
                    else{
                        this.ShiftplanQualificationCollectionToDelete().push(cell.DefaultModelToSave);
                    }
                    
                })
                item.WorkplacePlanningCollection.remove(model)
                this.TabPage.DirtyFlag(true);
            }
        });
    }

    public InitAddRow(employee: any){
        employee.SelectedShiftPlanQualificationModel = ko.observable();
        employee.AvailablePersonCollectionToShowHtml = null;
        employee.isAbsent = false;
        employee.IsDefault = false;
        employee.InvalidQualification = false;
        employee.AbsentColor = "";
        employee.AvailablePersonCollection = ko.observableArray([]);
        employee.AvailablePersonCollectionToShowHtml  = ko.observableArray([]);
        employee.AbsentColor = ko.observable("");
        employee.IsAbsent = ko.observable(false);
        employee.Color = ko.observable("");
        employee.IsFreeShift = ko.observable();
        employee.IsActive = ko.observable(true);
        employee.DefaultShiftbookId = ko.observable("");

        return employee;
    }

    addRow(resultData : any){
        return Bao.post("WorkplacePlanning/AddRow", JSON.stringify({
            shiftbookIds: this.ShiftBookId(),
            calendarDays: resultData.Calendar.length           
        })).then(result => {
            var newWorkplacePlanningCollection = [];
            var item2 = result.WorkplacePlanningModel;
            item2.WorkplaceId = null;
            item2.WorkplaceName = "";
            item2.IsAdditionalResource = true;
            item2.ColorString = ko.observable();
            item2.DefaultShiftbookId = "";
            item2.Employees = this.FillEmployees(resultData.Calendar, item2.Employees)
            let count = 0;
            resultData.WorkplacePlanningCollection().forEach(item => {
                count++;
                if(count == resultData.WorkplacePlanningCollection().length - 2){
                    item2.AvailableWorkplaces = ko.observableArray(item2.AvailableWorkplaces);
                    item2.SelectedWorkplace = ko.observable(item2.SelectedWorkplace);

                    item2.SelectedWorkplace.subscribe((data: any) => {
                        if (data) {
                            item2.DefaultShiftbookId = data.DefaultShiftbookId;                        
                        }
                        this.getAvailablePersonListbyWorkplace(data);
                    });
                    newWorkplacePlanningCollection.push(item2);
                }
                newWorkplacePlanningCollection.push(item);
            });

            resultData.WorkplacePlanningCollection(newWorkplacePlanningCollection);
            this.TabPage.DirtyFlag(true);
        });

    }

    getAvailablePersonListbyWorkplace(workplaceModel : any){
        if(workplaceModel !== null && workplaceModel !== undefined){
            this.TabPage.IsLoading(true);
            return Bao.post("WorkplacePlanning/GetAvailablePersonListbyWorkplace", JSON.stringify({
                workplaceId: workplaceModel.WorkplaceId,
                shiftGroupId: this.ShiftGroupId(),
                fromDate: this.ResultCollection()[0].Calendar[0].DateJs,
                toDate: this.ResultCollection()[0].Calendar[this.ResultCollection()[0].Calendar.length -1].DateJs,
                workplaceName: workplaceModel.Name,
                shiftbookIds: this.ShiftBookId()
            })).then(resultC => {
                
                this.InitAvailablePersonListbyWorkplace(resultC,workplaceModel);

                this.TabPage.IsLoading(false);
            });
        }
        
        
    }

    /*
     * this function is used to remove an existing element in an array
     * */
    public RemoveElementFromArray(array: any, element: any){

        const index = array.indexOf(element);

        if(index !== -1){
            array.splice(index, 1);
        }

        
    }

    /*
     * this function is used to find out the day index at which a person should be set.
     * */
    public GetAvailablePersonCollectionIndex(array, element){

        return array.findIndex(item => item.CIPersonId === element.CIPersonId);
    }

    /*
     * this function is used to check if there were previously selected employees in case of a change of a training position or an additional staffing.
     * If there was a fill for this job, the persons should be loaded again as originally.
     * */
    public CheckSelectedPersons(element: any, workplacePlanning: any, resultC: any, i: any){

        if(element && workplacePlanning.Employees[i].SelectedShiftPlanQualificationModel !== undefined){

            const index = this.GetAvailablePersonCollectionIndex(resultC.AvailablePersonCollection.Employees[i].AvailablePersonCollection,
                element);
            workplacePlanning.Employees[i].AvailablePersonCollection(resultC.AvailablePersonCollection.Employees[i].AvailablePersonCollection);
            workplacePlanning.Employees[i].SelectedShiftPlanQualificationModel(workplacePlanning.Employees[i].AvailablePersonCollection()[index]);
            
            workplacePlanning.Employees[i].IsActive(false);
            this.RemoveElementFromArray(this.PreviousWorkplaceModels(), element);
            
        }
        else{
            if(workplacePlanning.WorkplaceId !== null && 
                 ko.unwrap(workplacePlanning.Employees[i].SelectedShiftPlanQualificationModel) !== undefined &&
                 workplacePlanning.Employees[i].SelectedShiftPlanQualificationModel().CIPersonId != undefined){
       
                let prevShiftPlanQualificationModel: PrevShiftPlanQualificationModel = {
                    CIPersonId: workplacePlanning.Employees[i].SelectedShiftPlanQualificationModel().CIPersonId,
                    WorkplaceId:workplacePlanning.Employees[i].SelectedShiftPlanQualificationModel().WorkplaceId,
                    DayIndex: i,
                    
                };

                this.PreviousWorkplaceModels().push(prevShiftPlanQualificationModel);
            }
            workplacePlanning.Employees[i].AvailablePersonCollection(resultC.AvailablePersonCollection.Employees[i].AvailablePersonCollection);
            workplacePlanning.Employees[i].SelectedShiftPlanQualificationModel = ko.observable();
        }

    }

    /*
     * this function is used to remove the previous lists of persons when changing workplaces
     * */
    public RemovePreviousShiftplanQualificationModels(workplacePlanning: any, dayIndex: any){

        if(workplacePlanning.Employees[dayIndex].SelectedShiftPlanQualificationModel != undefined){

            let prevShiftPlanQualificationModel: ShiftPlanQualificationModel = workplacePlanning.Employees[dayIndex].SelectedShiftPlanQualificationModel();
            this.ShiftplanQualificationCollectionToDelete().push(prevShiftPlanQualificationModel);
        }

    }

    public InitAvailablePersonListbyWorkplace(resultC: any, workplaceModel: any){

        this.ResultCollection().forEach(result => {
    
            result.WorkplacePlanningCollection().forEach(workplacePlanning => {
                if(workplacePlanning.InTrainingId == workplaceModel.WorkplacePlanningId){                    
                    for(var i = 0; i < result.Calendar.length; i++){
                        this.RemovePreviousShiftplanQualificationModels(workplacePlanning,i);

                        const element = this.PreviousWorkplaceModels().find((el) => el.WorkplaceId === resultC.AvailablePersonCollection.WorkplaceId &&
                         el.DayIndex === i)

                         this.CheckSelectedPersons(element,workplacePlanning,resultC,i);

                        workplacePlanning.Employees[i].IsActive(true);
                            workplacePlanning.Employees[i].Color = ko.observable(resultC.AvailablePersonCollection.Employees[i].Color);
                            workplacePlanning.Employees[i].IsFreeShift = ko.observable(resultC.AvailablePersonCollection.Employees[i].IsFreeShift);
                            workplacePlanning.ColorString(resultC.AvailablePersonCollection.ColorString);                         
                            
                            workplacePlanning.Employees[i].AvailablePersonCollection().forEach(availablePerson => {
                                availablePerson.ShiftTypeId = result.Calendar[i].ShiftTypeId;
                                availablePerson.IsAdditionalResource = workplacePlanning.IsAdditionalResource;
                                availablePerson.IsInTraining = workplacePlanning.IsInTraining;                                
                            });
                            
                            workplacePlanning.Employees[i].SelectedShiftPlanQualificationModel.subscribe((data: any) => {
                                this.CheckIfIsAlreadyAssignedAndIsAbsence(this.ResultCollection());
                                this.setAvailableEmployeeCollectionToShow(this.ResultCollection());
                                this.TabPage.DirtyFlag(true);
                            });
                        

                    }

                }

            })

        })
    }

    getAvailablePersonListbyWorkplaceForTraining(workplaceModel : any){
        if(workplaceModel !== null && workplaceModel !== undefined){
            this.TabPage.IsLoading(true);
            return Bao.post("WorkplacePlanning/GetAvailablePersonListbyWorkplaceForTraining", JSON.stringify({
                workplaceId: workplaceModel.WorkplaceId,
                shiftGroupId: this.ShiftGroupId(),
                fromDate: this.ResultCollection()[0].Calendar[0].DateJs,
                toDate: this.ResultCollection()[0].Calendar[this.ResultCollection()[0].Calendar.length -1].DateJs,
                workplaceName: workplaceModel.Name,
                shiftbookIds: this.ShiftBookId()
            })).then(resultC => {
                
                this.InitAvailablePersonListbyWorkplace(resultC,workplaceModel);
                this.TabPage.IsLoading(false);
            });
        }
        
        
    }

    addRowTraining(resultData : any){
        return Bao.post("WorkplacePlanning/AddRowTraining", JSON.stringify({
            shiftbookIds: this.ShiftBookId(),
            calendarDays: resultData.Calendar.length
        })).then(result => {
            var newWorkplacePlanningCollection = [];
            var item2 = result.WorkplacePlanningModel;
            item2.WorkplaceId = null;
            item2.WorkplaceName = "";
            item2.IsInTraining = true;
            item2.ColorString = ko.observable();
            item2.DefaultShiftbookId = "";
            item2.Employees = this.FillEmployees(resultData.Calendar, item2.Employees)
            let count = 0;
            resultData.WorkplacePlanningCollection().forEach(item => {
                count++;
                if(count == resultData.WorkplacePlanningCollection().length - 2){
                    item2.AvailableWorkplaces = ko.observableArray(item2.AvailableWorkplaces);
                    item2.SelectedWorkplace = ko.observable(item2.SelectedWorkplace);

                    item2.SelectedWorkplace.subscribe((data: any) => {
                        if (data) {
                            item2.DefaultShiftbookId = data.DefaultShiftbookId;                        
                        }
                        this.getAvailablePersonListbyWorkplaceForTraining(data);
                    });
                    newWorkplacePlanningCollection.push(item2);
                }
                newWorkplacePlanningCollection.push(item);
            });

            resultData.WorkplacePlanningCollection(newWorkplacePlanningCollection);
            this.TabPage.DirtyFlag(true);
        });
    }

    

    public CreateavailableEmployeeCollectionToShow(resultCollection: any, k: any, j: any, i: any){
        var availableEmployeeCollectionToShow = [];

        resultCollection[i].WorkplacePlanningCollection()[k].Employees[j].AvailablePersonCollection().forEach(availableEmployee => {

            var found = false;
            for (let resultplanning  of resultCollection[i].WorkplacePlanningCollection()) {

                if(resultplanning.Employees[j].SelectedShiftPlanQualificationModel() !== undefined && 
                resultplanning.IsStatic !== true){

                    if (resultplanning.Employees[j].SelectedShiftPlanQualificationModel().CIPersonId === availableEmployee.CIPersonId) {
                        found = true;
                        break;
                    }
                }                
            }
            if (!found) {
                availableEmployeeCollectionToShow.push(availableEmployee)
            }
        });

        return availableEmployeeCollectionToShow;
    }

     setAvailableEmployeeCollectionToShow(resultCollection: any) {
        for (let i = 0; i < resultCollection.length; i++) {

            for(let j = 0; j < resultCollection[i].Calendar.length; j++) {

                for(let k = 0; k < resultCollection[i].WorkplacePlanningCollection().length; k++) {

                    if(resultCollection[i].WorkplacePlanningCollection()[k].IsStatic === true &&
                     resultCollection[i].WorkplacePlanningCollection()[k].IsAvailableEmployeeList === true &&
                      resultCollection[i].WorkplacePlanningCollection()[k].Employees[j].AvailablePersonCollection() !== undefined){

                        var availableEmployeeCollectionToShow = [];
                        
                        availableEmployeeCollectionToShow = this.CreateavailableEmployeeCollectionToShow(resultCollection,k,j,i);
                            
                        resultCollection[i].WorkplacePlanningCollection()[k].Employees[j].AvailablePersonCollectionToShowHtml(availableEmployeeCollectionToShow);
                        
                        
                    }
                }
            }
            
        }
    }

    public GetAbsentColor(resultCollection: any, k: any,j: any, result: any){
        let foundAbsentValue = false;
        var model: {IsAbsent: boolean, AbsentColor: string} = {IsAbsent: false, AbsentColor: ""};
        
        for(let l = 0; l < result.WorkplacePlanningCollection().length; l++){

            if(l !== k &&
                result.WorkplacePlanningCollection()[l].Employees[j].AvailablePersonCollectionToShowHtml() !== undefined &&
                result.WorkplacePlanningCollection()[l].IsAvailableEmployeeList !== true  &&
                result.WorkplacePlanningCollection()[l].IsStatic === true  &&
                result.WorkplacePlanningCollection()[l].Employees[j].AvailablePersonCollectionToShowHtml() != undefined){
                                                            
                    result.WorkplacePlanningCollection()[l].Employees[j].AvailablePersonCollectionToShowHtml().forEach(absentPerson => {

                                if(result.WorkplacePlanningCollection()[k].Employees[j].SelectedShiftPlanQualificationModel().CIPersonId == 
                                absentPerson.CIPersonId){

                                    model.AbsentColor = "red";
                                    model.IsAbsent = true;
                                    foundAbsentValue = true;
                            }
                        });                    
            } 
        }

        if(!foundAbsentValue){
            model.AbsentColor = "";
            model.IsAbsent = false;
        }

        return model;
    }

    /*
     * This method is used to check absences
     * */
     isAbsent(result: any, k: any, j: any, resultCollection: any) {
        if(result.WorkplacePlanningCollection()[k].IsStatic !== true && 
            result.WorkplacePlanningCollection()[k].Employees[j].SelectedShiftPlanQualificationModel() !== undefined &&
            result.WorkplacePlanningCollection()[k].Employees[j].SelectedShiftPlanQualificationModel().CIPersonId != null &&
            k + 1 <= result.WorkplacePlanningCollection().length - 1){                                
                var absentModel = this.GetAbsentColor(resultCollection, k, j, result);                           
                result.WorkplacePlanningCollection()[k].Employees[j].AbsentColor(absentModel.AbsentColor);
                result.WorkplacePlanningCollection()[k].Employees[j].IsAbsent(absentModel.IsAbsent);                             
            }
        else{
            result.WorkplacePlanningCollection()[k].Employees[j].AbsentColor("");
            result.WorkplacePlanningCollection()[k].Employees[j].IsAbsent(false);
        }
        
    }

    public CheckQualificationParameter(CIPersonId: any,color: any,IsWrongQualification: any,IsInTraining: any){
        if(CIPersonId != null && 
            color !== "orange" &&
            IsWrongQualification === true && 
                IsInTraining !== true){
                    return "orange"
                }
                return color;
    }

    public CheckAlreadyAssignedParameters(l: any,k: any,workplacePlanningCollection: any,j: any){
        if(l !== k &&
            workplacePlanningCollection[l].Employees[j].SelectedShiftPlanQualificationModel() !== undefined &&
                workplacePlanningCollection[l].Employees[j].SelectedShiftPlanQualificationModel().CIPersonId != null &&
                workplacePlanningCollection[k].Employees[j].SelectedShiftPlanQualificationModel().CIPersonId == 
                    workplacePlanningCollection[l].Employees[j].SelectedShiftPlanQualificationModel().CIPersonId)
                    {
                        return true;
                    }
                    return false;
    }


    /*
     * This method is used to check duplicate person assignments within 24 hours.
     * */
    public PlausibilityCheckAlreadyAssigned(selectedWpModelIndex: any,workplacePlanningCollection: any,selectedDayIndex: any){

        let dayIndex = 0;
        let foundDoubleValue = {value: false};
        for (let calendarDay of this.ResultCollection()[0].Calendar) {
            if (dayIndex != selectedDayIndex){
                if(calendarDay.Date == workplacePlanningCollection[selectedWpModelIndex].Employees[selectedDayIndex].ValidDate){
                    this.SetColorsForEmployeesWithDoubleShiftFounded(workplacePlanningCollection, selectedDayIndex, selectedWpModelIndex, dayIndex, foundDoubleValue);
                }
                else{
                    this.CheckDifferenceBetweenTwoShifts(selectedWpModelIndex,workplacePlanningCollection,selectedDayIndex,dayIndex,foundDoubleValue);
                }
            }            
            dayIndex++;            
        }
        return foundDoubleValue.value;
    }

    /*
     * This method is used to set color for duplicate person assignments within 24 hours
     * */
    public SetColorsForEmployeesWithDoubleShiftFounded(workplacePlanningCollection: any, selectedDayIndex: any, selectedWpModelIndex: any, dayIndex: any, foundDoubleValue: any){
        for(let workplacePlanning of workplacePlanningCollection){    
            if(workplacePlanningCollection[selectedWpModelIndex].Employees[selectedDayIndex].SelectedShiftPlanQualificationModel() !== undefined && 
            workplacePlanning.Employees[dayIndex].SelectedShiftPlanQualificationModel() !== undefined &&
            workplacePlanningCollection[selectedWpModelIndex].Employees[selectedDayIndex].SelectedShiftPlanQualificationModel().CIPersonId ==
            workplacePlanning.Employees[dayIndex].SelectedShiftPlanQualificationModel().CIPersonId){                         
                workplacePlanningCollection[selectedWpModelIndex].Employees[selectedDayIndex].Color("orange");
                workplacePlanning.Employees[dayIndex].Color("orange");
                foundDoubleValue.value = true;
            }
        }
    }

    /*
     * this method is used to check if there are 11 hours between two shifts
     * */
    public CheckDifferenceBetweenTwoShifts(selectedWpModelIndex: any, workplacePlanningCollection: any, selectedDayIndex: any,
        dayIndex: any, foundDoubleValue: any ){
            for (let workplacePlanning of workplacePlanningCollection){
                if (workplacePlanningCollection[selectedWpModelIndex].Employees[selectedDayIndex].SelectedShiftPlanQualificationModel() !== undefined && 
                    workplacePlanning.Employees[dayIndex].SelectedShiftPlanQualificationModel() !== undefined &&
                    workplacePlanningCollection[selectedWpModelIndex].Employees[selectedDayIndex].SelectedShiftPlanQualificationModel().CIPersonId ==
                    workplacePlanning.Employees[dayIndex].SelectedShiftPlanQualificationModel().CIPersonId &&
                    this.isLessthan11Hours(workplacePlanningCollection[selectedWpModelIndex].Employees[selectedDayIndex].StartDate,
                    workplacePlanning.Employees[dayIndex].StartDate)){

                    workplacePlanningCollection[selectedWpModelIndex].Employees[selectedDayIndex].Color("orange");
                    workplacePlanning.Employees[dayIndex].Color("orange");
                    foundDoubleValue.value = true
                }
            }        
    }

    /*
     * this method is used to check if there are 11 hours between two shifts
     * */
    public isLessthan11Hours(date1: any, date2: any){

        if (date1 != undefined && date2 != undefined){
           
            const dateSource = new Date(date1);
            const dateTarget = new Date(date2);
        
            const timeDiff = Math.abs(dateTarget.getTime() - dateSource.getTime());
            const diffHours = Math.ceil(timeDiff / (1000 * 3600));

            return diffHours < 11;
        }

        return false;
    }

    public InitisAlreadyAssigned(workplacePlanningCollection: any, k: any,j: any){
        if(workplacePlanningCollection[k].IsStatic !== true &&
        workplacePlanningCollection[k].Employees[j].SelectedShiftPlanQualificationModel() !== undefined &&
        workplacePlanningCollection[k].Employees[j].SelectedShiftPlanQualificationModel().CIPersonId != null &&
            k + 1 <= workplacePlanningCollection.length - 1){
                let foundDoubleValue = false;
                for(let l = 0; l < workplacePlanningCollection.length; l++){

                    
                    if(this.CheckAlreadyAssignedParameters(l,k,workplacePlanningCollection,j)){

                        workplacePlanningCollection[k].Employees[j].Color("orange");
                        workplacePlanningCollection[l].Employees[j].Color("orange");
                        foundDoubleValue = true;
                       
                    }
                                   
                }

                if(!foundDoubleValue && !this.PlausibilityCheckAlreadyAssigned(k,workplacePlanningCollection,j)){
                    workplacePlanningCollection[k].Employees[j].Color("");
                }

            //Check Qualification for Workplace
            
                
                    workplacePlanningCollection[k].Employees[j].Color(this.CheckQualificationParameter(workplacePlanningCollection[k].
                    Employees[j].SelectedShiftPlanQualificationModel().CIPersonId,workplacePlanningCollection[k].Employees[j].Color(),
                    workplacePlanningCollection[k].Employees[j].SelectedShiftPlanQualificationModel().IsWrongQualification,
                    workplacePlanningCollection[k].Employees[j].SelectedShiftPlanQualificationModel().IsInTraining));
                
            
        }
        else{
            workplacePlanningCollection[k].Employees[j].Color("");
        }
        
     
     return workplacePlanningCollection;
    }

    /*
     * This method is used to track if user is assigned and user absences
     * */
     CheckIfIsAlreadyAssignedAndIsAbsence(resultCollection: any) {
        for (let result of resultCollection) {
            for(let j = 0; j < result.Calendar.length; j++) {                
                for(let k = 0; k < result.WorkplacePlanningCollection().length; k++) {
                    this.isAbsent(result, k, j, resultCollection);
                    if (result.WorkplacePlanningCollection()[k].IsStatic){
                        continue
                    }
                    result.WorkplacePlanningCollection(this.InitisAlreadyAssigned(result.WorkplacePlanningCollection(),k,j));
                }
            }
        }        
    }  

     getDataFromServer() {       
        return Bao.post("WorkplacePlanning/GetWorkplacePlanningModel", JSON.stringify({
            shiftGroupId: this.ShiftGroupId(),
            shiftBookId: this.ShiftBookId(),
            startDate: this.StartDateTime(),
            endDate: this.EndDateTime(),
            dataSource: this.radioDataSource(),
            removeShiftBookGroup: this.RemoveShiftbookGroup()
        })).done(result => {
            if(result.TimeGapToLong){
                this.TabPage.IsLoading(false);
                return new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgTimeGapToLong"), "info");                
            }
            if (result.ResultCollection.length > 0) {
                this.SetFirstColumnWidth(result);

                result.ResultCollection.forEach(resultModel => {

                    resultModel.WorkplacePlanningCollection = ko.observableArray(resultModel.WorkplacePlanningCollection);

                    resultModel.WorkplacePlanningCollection().forEach(workplacePlanningModel => {
                        workplacePlanningModel.AvailableWorkplaces = ko.observableArray(workplacePlanningModel.AvailableWorkplaces);
                        var selectedWPindex = 0;
                        if (workplacePlanningModel.AvailableWorkplaces() !== null && workplacePlanningModel.AvailableWorkplaces !== undefined) {
                            for (let i = 0; i < workplacePlanningModel.AvailableWorkplaces().length; i++) {
                                if (workplacePlanningModel.SelectedWorkplace !== null &&
                                    workplacePlanningModel.AvailableWorkplaces()[i].WorkplaceId == workplacePlanningModel.SelectedWorkplace.WorkplaceId) {

                                    selectedWPindex = i;

                                }

                            }
                        }
                        workplacePlanningModel.SelectedWorkplace = ko.observable(workplacePlanningModel.AvailableWorkplaces()[selectedWPindex]);
                        workplacePlanningModel.ColorString = ko.observable(workplacePlanningModel.ColorString);
                        workplacePlanningModel.ColumnWidth = this.ColumnWidth();
                        workplacePlanningModel.Employees.forEach(workplacePlanningCellModel => {

                            workplacePlanningCellModel.AvailablePersonCollection = ko.observableArray(workplacePlanningCellModel.AvailablePersonCollection);
                            workplacePlanningCellModel.AvailablePersonCollectionToShowHtml = ko.observableArray(workplacePlanningCellModel.AvailablePersonCollectionToShowHtml);

                            workplacePlanningCellModel.SelectedShiftPlanQualificationModel = this.InitSelectedPersonModel(workplacePlanningCellModel);


                            workplacePlanningCellModel.Color = ko.observable(workplacePlanningCellModel.Color);
                            workplacePlanningCellModel.IsFreeShift = ko.observable(workplacePlanningCellModel.IsFreeShift);
                            workplacePlanningCellModel.AbsentColor = ko.observable();
                            workplacePlanningCellModel.IsAbsent = ko.observable(false);
                            workplacePlanningCellModel.IsActive = ko.observable(workplacePlanningCellModel.IsActive);
                            workplacePlanningCellModel.InvalidQualification = ko.observable<boolean>(false);
                        });

                    });

                });

            }
            //set subscribes foreach person dropdown
            this.initModel(result);
            this.ResultCollection(result.ResultCollection);
        });
    }
       
    public InitSelectedPersonModel(workplacePlanningCellModel: any){
        if(workplacePlanningCellModel.IsDefault){
            workplacePlanningCellModel.SelectedShiftPlanQualificationModel = ko.observable(workplacePlanningCellModel.AvailablePersonCollection()[0]);
            
        }
        else{

            let model: ShiftPlanQualificationModel = {
                CIPersonId: null,
                PersonFullName: "",
                WorkplaceId: "",
                Workplace: null,
                WorkplaceName: "",
                IsInTraining: false,
                IsAdditionalResource: false,
                Remark: "",
                ShiftTypeId: "",
                ShiftbookId: "",
                ShiftGroupId: "",
                ValidDateJs: "",
                IsNew: true,
                Person: null,
                IsPersonIncorrect: null,
                IsWrongQualification: null,
                IsAlreadyAssigned: null,
                IsAbsent: null,
                QualificationIdsByPerson: null,
                QualificationIdsByWorkplace: null,
                ValidDate: "",
                SyncId: null
            };

            workplacePlanningCellModel.SelectedShiftPlanQualificationModel = ko.observable<ShiftPlanQualificationModel>(model);
        }
        return workplacePlanningCellModel.SelectedShiftPlanQualificationModel;
    }

    public initModel(result: any){
        result.ResultCollection.forEach(resultModel => {
                
            resultModel.WorkplacePlanningCollection().forEach(workplacePlanningModel => {
                
                if(workplacePlanningModel.IsAdditionalResource){
                    workplacePlanningModel.SelectedWorkplace.subscribe((data: any) => {
                    
                        this.getAvailablePersonListbyWorkplace(data);

                    });
                }
                
                if(workplacePlanningModel.IsInTraining){
                    workplacePlanningModel.SelectedWorkplace.subscribe((data: any) => {
                    
                        this.getAvailablePersonListbyWorkplaceForTraining(data);

                    });
                }

                workplacePlanningModel.Employees.forEach(workplacePlanningCellModel => {

                    workplacePlanningCellModel.SelectedShiftPlanQualificationModel.subscribe((data: any) => {
                        this.CheckIfIsAlreadyAssignedAndIsAbsence(result.ResultCollection);
                        this.setAvailableEmployeeCollectionToShow(result.ResultCollection);
                        this.TabPage.DirtyFlag(true);
                    });

                });

            });

        });
    }

     recalcScroll() {
        this.HeaderLeft(-window.pageXOffset + 'px');
    }

     recalcSchedulePosition() {
        $(this.ReportHTML()).find(".job-occupation-table").css("top", $(this.ReportHTML()).find(".filters").height() + 33);
    }

     ResizeEventHandler = (e) => {
        this.recalcSchedulePosition();
        this.recalcScroll();
    }

     ScrollEventHandler = (e) => {
        e.preventDefault();
        this.recalcScroll();
    }

     openCopyDialog() {

        if(this.TabPage.IsDirty()){
            this.CheckDirtyFlagForCopyDialog();
        }
        else{
            this.CopyDialogServerCell();
        }

        
    }

    CopyDialogServerCell(){
        if (this.ShiftBookId() && this.StartDateTime()) {
            this.TabPage.IsLoading(true);
            return Bao.post("WorkplacePlanning/WorkplacePlanningCopyDialog")
                .done(result => {
                    let workplacePlanningCopyDialog = new BaoDialog(Bao.Session.GetMessage("msgCopyWorkplacePlanning"), result.Template);                                      

                    if (this.ResultCollection()[0].Calendar.length > 0) {
                        workplacePlanningCopyDialog.ViewModel(new WorkplacePlanningCopyDialog(this.ShiftGroupId(), this.ShiftGroupName(),this.ResultCollection()[0].Calendar[0].DateJs, this.EndDateTime(), this.ShiftbookIdsStringifiedForCustomFilter()));
                    }
                    else {
                        workplacePlanningCopyDialog.ViewModel(new WorkplacePlanningCopyDialog(this.ShiftGroupId(), this.ShiftGroupName(), this.StartDateTime(), this.EndDateTime(), this.ShiftbookIdsStringifiedForCustomFilter()));
                    }

                    workplacePlanningCopyDialog.Buttons([
                        new BaoDialog.ButtonFactory(workplacePlanningCopyDialog, Bao.Session.GetMessage("msgCopy"), () => {
                            if ((<WorkplacePlanningCopyDialog>workplacePlanningCopyDialog.ViewModel()).FromDate() && (<WorkplacePlanningCopyDialog>workplacePlanningCopyDialog.ViewModel()).ToDate()) {

                                this.copyData(workplacePlanningCopyDialog);
                                
                            } else {
                                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                            }
                        }),
                        new BaoDialog.ButtonFactory(workplacePlanningCopyDialog, Bao.Session.GetMessage("msgCancel"), () => {
                            workplacePlanningCopyDialog.Close();
                        })
                    ]);
                    workplacePlanningCopyDialog.Width("500px");
                    workplacePlanningCopyDialog.Open();
                    this.TabPage.IsLoading(false);
                });
        }
    }

    CheckDirtyFlagForDisplay() {
        if (this.TabPage.IsDirty()) {
            this.TabPage.IsLoading(true);
            
                    let CheckDirtyFlagForDisplayDialog = new BaoDialog(Bao.Session.ApplicationName,Bao.Session.GetMessage("msgCheckWorkplaceplanningReload"));
                    
                    CheckDirtyFlagForDisplayDialog.Buttons([
                        new BaoDialog.ButtonFactory(CheckDirtyFlagForDisplayDialog, Bao.Session.GetMessage("msgYes"), () => {
                            this.TabPage.IsLoading(true)
                            this.getDataFromServer().then(data => {
                                
                                this.recalcScroll();
                                this.TabPage.DirtyFlag(false);
                                this.TabPage.IsLoading(false);
                                CheckDirtyFlagForDisplayDialog.Close();
                            });
                        }),
                        new BaoDialog.ButtonFactory(CheckDirtyFlagForDisplayDialog, Bao.Session.GetMessage("msgCancel"), () => {
                            CheckDirtyFlagForDisplayDialog.Close();
                        })
                    ]);

                    CheckDirtyFlagForDisplayDialog.Width("500px");
                    CheckDirtyFlagForDisplayDialog.Open();
                    this.TabPage.IsLoading(false);
                
        }
    }

    CheckDirtyFlagForCopyDialog() {
        if (this.TabPage.IsDirty()) {
            this.TabPage.IsLoading(true);
            
                    let CheckDirtyFlagForDisplayDialog = 
                    new BaoDialog(Bao.Session.ApplicationName,Bao.Session.GetMessage("msgCheckOpenCopyDialogDirtyFlag"));
                    
                    CheckDirtyFlagForDisplayDialog.
                    Buttons([
                        new BaoDialog.ButtonFactory(CheckDirtyFlagForDisplayDialog, Bao.Session.GetMessage("msgYes"), () => {
                            this.TabPage.IsLoading(true)
                            this.CopyDialogServerCell();
                        }),
                        new BaoDialog.ButtonFactory(CheckDirtyFlagForDisplayDialog, Bao.Session.GetMessage("msgCancel"), () => {
                            CheckDirtyFlagForDisplayDialog.Close();
                        })
                    ]);

                    CheckDirtyFlagForDisplayDialog.Width("500px");
                    CheckDirtyFlagForDisplayDialog.Open();
                    this.TabPage.IsLoading(false);
                
        }
    }

     copyData(workplacePlanningCopyDialog: BaoDialog) {
        if(this.CopyDataCompleteCheck(workplacePlanningCopyDialog)){
            this.TabPage.IsLoading(true);
            Bao.post("WorkplacePlanning/CopyWorkplacePlanningData", JSON.stringify({
                shiftbookId: this.ShiftBookId(),
                shiftGroupId: (<WorkplacePlanningCopyDialog>workplacePlanningCopyDialog.ViewModel()).ShiftGroupId(),
                sourceDate: (<WorkplacePlanningCopyDialog>workplacePlanningCopyDialog.ViewModel()).SourceDate(),
                fromDate: (<WorkplacePlanningCopyDialog>workplacePlanningCopyDialog.ViewModel()).FromDate(),
                toDate: (<WorkplacePlanningCopyDialog>workplacePlanningCopyDialog.ViewModel()).ToDate(),
                overwriteTarget: (<WorkplacePlanningCopyDialog>workplacePlanningCopyDialog.ViewModel()).OverwriteTarget(),
            })).done(() => {
                workplacePlanningCopyDialog.Close();
            }).always(result => {
                this.TabPage.IsLoading(false);
                this.Display(false);
            });
        }
    }

    /*
    * This function checks if the data from the workplacePlanningCopyDialog is complete.
    * */
    CopyDataCompleteCheck(workplacePlanningCopyDialog: BaoDialog){
        let isComplete = false;
        let workplacePlanningCopyDialogVM : WorkplacePlanningCopyDialog = workplacePlanningCopyDialog.ViewModel();
        if(workplacePlanningCopyDialogVM.ShiftGroupId() 
            && workplacePlanningCopyDialogVM.SourceDate() 
            && workplacePlanningCopyDialogVM.FromDate() 
            && workplacePlanningCopyDialogVM.ToDate()){
            isComplete = true;
        }

        if(!isComplete){
            new BaoDialog(Bao.Session.ApplicationName,
                Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }

        return isComplete;
    }

    /*
     * This function is used to make columns editable for a selected day
     * */
    EditColumn (data: any){
        this.TabPage.IsLoading(true);
        for (let result of this.ResultCollection()) {

            for(let j = 0; j < result.Calendar.length; j++) {

                for(let line of result.WorkplacePlanningCollection()) {

                    this.ActivateColumn(line, data, j);
                }
            }
            
        }
        this.TabPage.IsLoading(false);
    }

    /**
     * Opens DialyShiftPlan tab
     * @param data selected column
     */
    GoToDailyShiftPlan(data: any) {
        const date = moment(data.Date, Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeFormat);
        baoRouter.setHash(`ShiftSchedule/DailyPlan/${data.ShiftbookId}/${data.ShiftGroupId}/${data.ShiftTypeId}/${date}`);
    }

    /*
     * This function activates the column for a selected day
     * */
    ActivateColumn(line: any,data: any,index: any){

        if(this.RemoveShiftbookGroup() === true){

            if(line.IsStatic !== true &&
                line.Employees[index].ValidDate === data.Date &&
                line.Employees[index].ShiftGroupId === data.ShiftGroupId){                        
                    
                    line.Employees[index].IsActive(true);     

            }
        }
        else{
            if(line.IsStatic !== true &&
                line.Employees[index].ValidDate === data.Date &&
                line.Employees[index].ShiftbookId === data.ShiftbookId &&
                line.Employees[index].ShiftGroupId === data.ShiftGroupId){                        
                    
                    line.Employees[index].IsActive(true);     

            }
        }

    }

    /*
     * This function is used to open the Report JobOccupation
     * */
    openReportCenter() {
        window.open("#/reportcenter/" + ReportCenterReports.JobOccupationExplorer + "/" + ReportCenterReports.JobOccupationReport + "/", "_self");
        
    }

    

    /*
     * This function is used to download a report with the help of evo pdf
     * */
    DownloadEvoPdfHtmlReportWorkplacePlanning = () => {
        let deferred = $.Deferred(); 
    
        if (!this.checkFilters(false)) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            deferred.reject(); 
            return deferred.promise(); 
        }
    
        if (this.DisplayView() == "horizontal") {
            this.DisplayView("horizontalReport");
        } else if (this.DisplayView() == "vertical") {
            this.DisplayView("verticalReport");
        }
    
        let element = document.getElementById("jobOc_table_report_container");
        let elementHtml = element.innerHTML;
        this.TabPage.IsLoading(true);
    
        Bao.post("ReportCenter/GetDownloadPDF/", JSON.stringify({ currentPageHtmlString: elementHtml }), (result) => {
            baoRouter.setHash("#document/"  + result.Result);
            this.TabPage.IsLoading(false);
            deferred.resolve(); 
        });
    
        return deferred.promise(); 
    };   

    PermissionRefresh: KnockoutObservable<string> = ko.observable("na");
    PermissionSave: KnockoutObservable<string> = ko.observable("na");
    PermissionDelete: KnockoutObservable<string> = ko.observable("na");
    PermissionQRCode: KnockoutObservable<string> = ko.observable("na");
    // override to avoid this.UnlockUrl call
    BeforeClose(closeFn) {
        if (this.TabPage.DirtyFlag()) {

            var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheckWP"), "question");

            questionDialog.DialogResult.subscribe(function (result) {

                if (result === true) {
                                  
                  return closeFn();      

                }
                
            });
        }
        else {
            
            return closeFn();           
        }
    }

    /*
     * This method gets WorkplacePlanningModel
     * */
    protected GetWorkplacePlanningModel(model: any, shiftBookModel: any, defaultShiftbookId: string){        
        if (this.ShiftBookId().length <= 1 || (!model.IsInTraining && !model.IsAdditionalResource)) {
            return model;
        }
        
        if (!this.RemoveShiftbookGroup()){
            model.ShiftGroupId = shiftBookModel.ShiftGroupId;
            model.DefaultShiftGroupName = shiftBookModel.ShiftGroupName;
            model.ShiftbookId = shiftBookModel.ShiftbookId;    
        } 
        else {
            model.ShiftbookId = defaultShiftbookId;    
        }           
        return model;
    }

    /*
     * This method fill employees list with correct data (including ValidDate - needed for day segregation break line)
     * */
    protected FillEmployees(calendar: any, employees: any){
        let count = 0;
        employees.forEach(employee => {
            employee.ValidDate = calendar[count].Date; 
            this.InitAddRow(employee);
            count++;
        });
        return employees;
    }

    /*
     * This method sets the minimum width of the first column
     * */
    protected SetFirstColumnWidth(result: any){
        let workplaceNameStringLength = Math.max(...result.ResultCollection[0]
            .WorkplacePlanningCollection.map(elements => {
                return elements.WorkplaceName.length;
            }));

        let minimumWorkplaceNameStringLength = 10;

        this.ColumnWidth(`${(workplaceNameStringLength > minimumWorkplaceNameStringLength 
            ? workplaceNameStringLength 
            : minimumWorkplaceNameStringLength) 
            * 0.95}rem`);
    }

}
export default WorkplacePlanning;
